// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';

/** メッセージ内の置き換え文字列定義 */
const TIME = '$TIME$';

/** errorアクション定義 */
const ERR_EXECUTE = 'execute';
const ERR_CONFIRM = 'confirm';
const ERR_STOP = 'stop';
const ERR_EXIT = 'exit';

/** レスポンス定数定義 */
const RESULT_NORMAL = 'normal';         // 正常
const RESULT_CONTINUE = 'continue';     // 継続
const RESULT_UNSUITABLE = 'unsuitable'; //不成立

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  START_REMOVING: 'startRemoving',
  REMOVING: 'removing',
  FIRST_SUCCESS: 'firstSuccess',
  COOLING_STOP: 'coolingStop',
  COOLING_SUCCESS: 'coolingSuccess',
  COOLING_FAILED: 'coolingFailed',
  COOLING_COMMUNICATION_ERROR: 'coolingCommunicationError',
  COMPLETE: 'complete',
  STOP_REMOVING: 'stopRemoving',
  UNSUITABLE: 'unsuitable',
  CONNECTION_FAILED: 'connectionFailed',
};

export default {
  name: 'requirement009',
  data() {
    return {
      phase: PHASE.START,
      modeList: [],
      resultCode: '',
      selectedMode: '',
      replaceMessage: '',
      remainingTime: 0,
      waitTime: 0,
      interval: 60000,
      intervalId: null,
      isLoading: false,
      isDisabled: false,
      whichType: '',
      modal_requirement_009: false
    };
  },
  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        //赤
        case PHASE.COOLING_FAILED:
        case PHASE.CONNECTION_FAILED:
        case PHASE.COOLING_COMMUNICATION_ERROR:
        case PHASE.UNSUITABLE:
          return 'danger';
        //黄緑
        case PHASE.FIRST_SUCCESS:
        case PHASE.COOLING_SUCCESS:
          return 'success';
        //紺
        case PHASE.START:
        case PHASE.START_REMOVING:
        case PHASE.STOP_REMOVING:
        case PHASE.COOLING_STOP:
        case PHASE.COMPLETE:
        case PHASE.REMOVING:
        default:
          return 'secondary';
      }
    }
  },

  async mounted() {
    this.init();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('cache', ['cacheVin']),

    /** 初期化処理 */
    init() {
      // モード一覧作成
      this.modeList = [
        { value: "stop", text: this.$t(`individual.label_mode_stop`) },
        { value: "run", text: this.$t(`individual.label_mode_run`) }
      ];
      this.modal_requirement_009 = true;
      //EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    //----- htmlイベントメソッド -----------------------------------------------//

    /** 閉じるボタンクリックイベント */
    async clickClose() {
      this.$emit('close-wizard');
      this.modal_requirement_009 = false;
    },

    /** 終了処理(ルーチン停止を含まない)実行ボタンクリックイベント */
    async clickExit() {
      await this.exitPostGet();
      this.clickClose();
    },

    /** 待機画面のOKボタンクリックイベント */
    clickShowStartRemoving() {
      if (this.selectedMode !== '') {
        this.phase = PHASE.START_REMOVING;
      }
    },

    /** API実行開始ボタンクリックイベント */
    async clickFirstExecute() {
      await this.executePostGet();
    },

    /** 中止画面表示するボタンクリックイベント */
    clickShowStop() {
      this.isLoading = false;
      this.isDisabled = false;
      this.phase = PHASE.STOP_REMOVING;    //中止画面表示
    },

    /** 中止画面のOKボタンクリックイベント */
    async clickCoolingStop() {
      this.showPhaseCooling(PHASE.COOLING_STOP, this.$t(`${this.i18nWsKey}.REQ_WS_9_TXT_10`));  //冷却中（中止）画面表示
    },

    /** 中止画面のキャンセルボタンクリックイベント */
    async clickRemoving() {
      this.phase = PHASE.REMOVING;
      await this.confirmPostGet();
    },

    //----- PHASE操作メソッド -----------------------------------------------//

    /**
     * 初回実行：成功画面または実行条件不成立画面 表示メソッド
     * @param {string} myPhase 対象のPhase
    */
    async showFirstResultDisplay(myPhase) {
      //中止画面表示時は次画面遷移なし(非同期対応)
      if (this.phase === PHASE.STOP_REMOVING) {
        this.isLoading = false;
        return;
      }
      //終了処理
      this.phase = myPhase;
      await this.stopPostGet();
    },

    /** 2回目以降：除去状況確認表示メソッド */
    async showRemoving() {
      //中止画面表示中の場合はAPI処理をさせない(非同期対応)
      if (this.phase === PHASE.STOP_REMOVING) {
        this.isLoading = false;
        return;
      }
      this.phase = PHASE.REMOVING;
      await this.confirmPostGet();
    },

    /**
     * 冷却中表示（正常終了、異常終了、通信エラー）メソッド
     * @param {string} myPhase 対象のPhase
     * @param {string} phaseMessage 対象の文言
    */
    async showPhaseCooling(myPhase, phaseMessage) {

      //中止画面からCALLされた時以外で、中止画面表示時は次画面遷移なし(非同期対応)
      if (myPhase !== PHASE.COOLING_STOP && this.phase === PHASE.STOP_REMOVING) {
        return;
      }

      //終了処理（ウェイト時間取得）
      //第二引数true：終了処理でスピナーがONになり、OFFにしないで戻ってくる
      await this.stopPostGet(true);

      try {
        //初回表示時間
        const mm = util.timeSpanConverter(this.waitTime).minutes;
        this.replaceMessage = phaseMessage.replace(TIME, mm);
        this.phase = myPhase;
        //指定時間経過の計測を行い、画面に残り時間を表示
        this.remainingTime = this.waitTime;
        while (this.remainingTime > 0) {
          //this.interval秒wait
          await util.sleep(this.interval);
          //経過時間をマイナス
          this.remainingTime -= this.interval;
          //メッセージ表示
          const mm = util.timeSpanConverter(this.remainingTime).minutes;
          this.replaceMessage = phaseMessage.replace(TIME, mm);
        }

      } finally {
        //スピナーOFF（終了処理でONになっている）
        this.isLoading = false;
      }

      //指定時間経過後、完了画面表示
      this.phase = PHASE.COMPLETE;
    },

    //----- バックエンドAPI実行メソッド -----------------------------------------------//
    /**
     * ルーチン処理初回（要求）メソッド
    */
    async executePostGet() {

      try {
        this.isLoading = true;
        this.isDisabled = true;

        //共通エラー関数内の分岐で使用
        this.whichType = ERR_EXECUTE;

        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute',
            mode: this.selectedMode,
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        //正常
        if (response) {
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            switch (response.data.user_data.result) {
              case RESULT_NORMAL:
                this.showFirstResultDisplay(PHASE.FIRST_SUCCESS);
                break;
              case RESULT_CONTINUE:
                await this.showRemoving();
                break;
              case RESULT_UNSUITABLE:
              default:
                this.resultCode = response.data.user_data.code;
                this.showFirstResultDisplay(PHASE.UNSUITABLE);
                break;
            }
          }
          //ステータス：異常
          else {
            this.showUnexpectedError();
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },

    /**
     * ルーチン処理（要求）メソッド
    */
    async confirmPostGet() {

      try {
        this.isLoading = true;
        this.isDisabled = true;

        //共通エラー関数内の分岐で使用
        this.whichType = ERR_CONFIRM;

        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'confirm',
            mode: this.selectedMode,
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        //正常
        if (response) {
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            switch (response.data.user_data.result) {
              case RESULT_NORMAL:
                await this.showPhaseCooling(PHASE.COOLING_SUCCESS, this.$t(`${this.i18nWsKey}.REQ_WS_9_TXT_7_0002`));
                break;
              case RESULT_CONTINUE:
                await this.showRemoving();
                break;
              case RESULT_UNSUITABLE:
              default:
                await this.showPhaseCooling(PHASE.COOLING_FAILED, this.$t(`${this.i18nWsKey}.REQ_WS_9_TXT_8_${response.data.user_data.code}`));
                break;
            }
          }
          //ステータス：異常
          else {
            //2回目以降のステータス異常(正常以外)
            this.showPhaseCooling(PHASE.COOLING_COMMUNICATION_ERROR, this.$t(`${this.i18nWsKey}.REQ_WS_9_TXT_9`));
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },

    /**
     * 終了処理（ルーチン停止処理あり）メソッド
     * @param {boolean} finallyLoadingSw finallyでスピナーOFFにしない場合はtrue、省略時はfalse
    */
    async stopPostGet(finallyLoadingSw = false) {

      try {
        this.isLoading = true;
        this.isDisabled = true;

        //共通エラー関数内の分岐で使用
        this.whichType = ERR_STOP;

        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop',
            mode: this.selectedMode,
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          //ウエイト時間取得
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            this.waitTime = response.data.user_data.wait_time;
          }
        }

      } finally {
        this.isLoading = finallyLoadingSw;
        this.isDisabled = false;
      }

    },

    /**
     * 終了処理メソッド
    */
    async exitPostGet() {

      try {
        this.isLoading = true;
        this.isDisabled = true;

        //共通エラー関数内の分岐で使用
        this.whichType = ERR_EXIT;

        //バックエンドAPI POST,GET
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit',
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }

    },

    //----- エラーメソッド -----------------------------------------------//
    /**
     * 共通エラー表示メソッド 
    */
    showUnexpectedError() {

      //中止画面表示時は次画面遷移なし(非同期対応)
      if (this.phase === PHASE.STOP_REMOVING) {
        this.isLoading = false;
        return;
      }

      //エラーアクション分岐
      switch (this.whichType) {
        case ERR_EXECUTE:
          this.isLoading = false; //cooling中の終了処理から呼び出された場合はスピナーONのままのためOFFにする
          this.phase = PHASE.CONNECTION_FAILED;
          break;
        case ERR_CONFIRM:
          this.showPhaseCooling(PHASE.COOLING_COMMUNICATION_ERROR, this.$t(`${this.i18nWsKey}.REQ_WS_9_TXT_9`));
          break;
        case ERR_STOP:
        case ERR_EXIT:
        default:
          // 何もしない
          break;
      }
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
   */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

  },
};